export default __webpack_public_path__ + "static/media/LogoUnboardBeta.eff7cad5.png";